import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { parseShortDateTime } from '../../../../utils/dates';

export default function ReferralDetails({ referral }) {
  return (
    <React.Fragment>
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Referral details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Date received" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateTime(referral.dateReceived)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Referral priority" />
            <span className="divider" />
            <ListItemText secondary={referral.referralPriority.name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Referral source" />
            <span className="divider" />
            <ListItemText secondary={referral.referralSource.name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Allocated to unit" />
            <span className="divider" />
            <ListItemText secondary={referral.orgUnit.name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Location type" />
            <span className="divider" />
            <ListItemText secondary={referral.locationType ? referral.locationType.name : '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Referral service" />
            <span className="divider" />
            <ListItemText secondary={referral.referralService ? referral.referralService.name : '-'} />
          </ListItem>
        </List>
      </div>
    </React.Fragment>
  );
}
